import React, {useContext} from 'react';
import {AppContext, triggerIgniteAction} from '../state';

/**
 * @typedef AnalyticsHookValues
 * @property {function} actionCompleted - function call to complete an Ignite analytic action
 * @property {function} actionStarted - function call to indicate an Ignite analytic action was started
 *
 * @return {AnalyticsHookValues}
 */
const useAnalytics = () => {
  const { dispatch } = useContext(AppContext);
  const actionCompleted = React.useCallback(({ actionName, productId }) => {
    dispatch( triggerIgniteAction({ actionName, productId, value: 'completed' }) );
  }, [ dispatch ]);
  const actionStarted = React.useCallback(({ actionName, productId }) => {
    dispatch( triggerIgniteAction({ actionName, productId, value: 'started' }) );
  }, [ dispatch ]);

  return {
    actionCompleted,
    actionStarted
  };
};

export {
  useAnalytics
};
